import { Navigate, Outlet, useLocation } from "react-router";
import { useMe } from "@/lib/auth";

/**
 * Outlet wrapper that gates child routes on a successful /api/me call.
 *
 * - Loading: render a minimal placeholder so the dashboard shell can paint quickly.
 * - 401 / error: navigate to /login?next=<current-path-and-search>, replacing history.
 * - 200: render <Outlet/> for the gated child route.
 */
export function RequireAuth() {
  const { data, isLoading, isError } = useMe();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-dvh bg-background" aria-busy="true" aria-label="Loading session" />
    );
  }

  if (isError || !data) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <Outlet />;
}
